import get from 'lodash/get';

export interface Location {
  name: string;
  street1: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

// @ts-ignore
export const getLocation = (location): Location => ({
  name: get(location, ['name']) || '',
  street1: get(location, ['street1']) || '',
  city: get(location, ['city']) || '',
  state: get(location, ['state']) || '',
  zip: get(location, ['zip']) || '',
  country: get(location, ['country']) || '',
});

// @ts-ignore
export const getLegacyLocation = (event): Location => ({
  name: get(event, ['vendor_name']) || '',
  street1: get(event, ['gdsAddress', 'street1']) || '',
  city: get(event, ['gdsAddress', 'city']) || '',
  state: get(event, ['gdsAddress', 'state']) || '',
  zip: get(event, ['gdsAddress', 'zip']) || '',
  country: get(event, ['gdsAddress', 'country']) || '',
});
